import React, { useState, useRef } from 'react';
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import { useTaskList } from '../../../Hooks/Features/Task/useTaskList';
import TaskDetailsPopup from '../../../components/TaskList/TaskDetailsPopup';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Pagination from "../../../components/CommonCompo/Pagination/pagination";
import { MultiSelect } from 'primereact/multiselect';
import DatePicker from 'react-multi-date-picker';
import UpdateTaskStatus from '../../../components/Poker/UpdateTaskStatus';
import { renderField } from '../../../utils/Helper';
import { Calendar } from 'primereact/calendar';
import _ from "underscore";
import { useCommon } from '../../../Hooks/Common/useCommon';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

const TaskList = () => {

    const { getValuePermission } = useCommon();
    const { columns, taskDetailsPopup, setTaskDetailsPopup, rowdata, filterValue, setFilterValue, option, expanded, setExpanded, handleChange, pagination, setPagination, loader, getTaskList, options, popupValue, setPopupValue, updateReviewer, taskListRef, filterFields, optionCount, filterKeys, handleReset, handleProjectChange, multiselectRef ,overlayRef} = useTaskList();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const createdDatePickerRef = useRef(null);
    const updatedDatePickerRef = useRef(null);

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center sk-header-row px-2'>
                <div className='w80 d-flex gap-1 align-items-center'>
                    <div className="w15">
                        <input placeholder='Filter Issue Key...' className='sk-input-dd w100 mb-0' value={filterValue?.search} onChange={(e) => setFilterValue((prev) => ({ ...prev, search: e?.target?.value }))} />
                    </div>
                    <div className="w80 d-flex">
                        <div className='w80'>
                            <CommonFilterDropdown fields={[{ key: "projects", label: "Projects", col: 3, onHide: () => { if (filterValue?.isChange) { handleProjectChange(); } } }, { key: "assignee", label: "Assignee", col: 3, options: option?.assignee || [], onHide: () => { getTaskList(); } }, { key: "issue_status", label: "Status", col: 3, options: option?.issue_status || [], onHide: () => { getTaskList(); } }, { key: "issue_type", label: "Work Type", col: 3, options: option?.issue_type || [], onHide: () => { getTaskList(); } }]} filterValues={filterValue} setFilterValues={setFilterValue} />
                        </div>
                        <div className='w20'>
                            <DatePicker format='DD-MM-YYYY' style={{ width: "100%" }} placeholder='Created Date Range' range rangeHover value={filterValue?.createdDate} onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, createdDate: e, isChange: true }));
                                            }
                                        }} onClose={() => { if (filterValue?.isChange) getTaskList() }} />
                        </div>
                    </div>
                    <div className='w5'>
                        <button className='sk-btn sk-btn-primary d-flex gap-1 align-items-center' onClick={(e) => { overlayRef?.current?.toggle(e); }}>Filters <FontAwesomeIcon icon="fa-solid fa-angle-down" /></button>
                    </div>
                </div>
                <div className='w20 d-flex gap-1 align-items-center justify-content-end'>
                    <div className="w40">
                        <Dropdown
                            value={filterValue?.groups}
                            onChange={handleChange}
                            placeholder="Group"
                            options={option?.agileGroups}
                            optionLabel="group_name"
                            className="sk-multiselect"
                            panelClassName="sk-multiselect-panel"
                            name='groups'
                            filter
                            showClear
                            filterInputAutoFocus />
                    </div>
                    {
                        expanded ? <button title="Collapse All" className="sk-btn sk-btn-primary rounded" onClick={() => setExpanded(false)}><FontAwesomeIcon icon="fa-solid fa-list" /></button> : <button title="Expand All" className="sk-btn sk-btn-primary rounded" onClick={() => setExpanded(true)}><FontAwesomeIcon icon="fa-solid fa-expand" /></button>
                    }
                    <button className="sk-btn sk-btn-primary rounded" onClick={() => getTaskList()} title="Refresh">
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button className="sk-btn sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                </div>
            </div>
            <div className='mx-2' style={{ height: "calc(100vh - 140px)", overflow: "auto" }} ref={taskListRef}>
                <CommonGrid
                    columns={columns}
                    data={rowdata}
                    headerHeight={40}
                    rowHeight={40}
                    loader={loader}
                    // strippedTable={true}
                    expandAll={expanded}
                />
            </div>
            <Pagination totalRecords={pagination?.total_records} totalPages={pagination?.total_pages} currentPage={pagination?.current_page} displayPageOutOfTotal={pagination?.display_page_out_of_total} onPageChange={(e) => { setPagination((prev) => ({ ...prev, current_page: e })); }} />

            {popupValue?.show && <UpdateTaskStatus options={options} popupValue={popupValue} setPopupValue={setPopupValue} updateReviewer={() => updateReviewer(true)} />}

            {!getValuePermission("task_list_details") && taskDetailsPopup?.show &&
                <Dialog visible={taskDetailsPopup?.show} draggable={false} style={{ height: "85vh", width: "70rem", maxWidth: "70rem" }} className='modal-xlarge task-details' onHide={() => setTaskDetailsPopup((prev) => ({ ...prev, show: false }))}>
                    <TaskDetailsPopup setTaskDetailsPopup={setTaskDetailsPopup} data={taskDetailsPopup?.data || { project_id: 0 }} />
                </Dialog>
            }

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => { handleReset() }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Agile Groups Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Agile Groups</div>
                                <Dropdown
                                    value={filterValue?.groups}
                                    onChange={handleChange}
                                    placeholder="Select a group"
                                    options={option?.agileGroups}
                                    optionLabel="group_name"
                                    className="sk-input-dd w-100"
                                    name='groups'
                                    filter
                                    showClear
                                    filterInputAutoFocus />
                            </div>

                            {/* Core Filters */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Core Filters</div>
                                <CommonFilterDropdown fields={[{ key: "projects", label: "Projects", col: 12, onHide: () => { if (filterValue?.isChange) { handleProjectChange(); } } }, { key: "assignee", label: "Assignee", col: 12, options: option?.assignee || [], onHide: () => { getTaskList(); } }, { key: "issue_status", label: "Status", col: 12, onHide: () => { getTaskList(); } }, { key: "issue_type", label: "Work Type", col: 12, options: option?.issue_type || [], onHide: () => { getTaskList(); } }]} filterValues={filterValue} setFilterValues={setFilterValue} />
                            </div>

                            {filterFields?.map((item, index) => (
                                <div key={index} className="sk-drawer-filter-group">
                                    {renderField(item, index, (e) => { setFilterValue((prev) => ({ ...prev, [item?.name]: e?.target?.value, isChange: true })) }, filterValue, {}, {}, () => { }, () => { })}
                                </div>
                            ))}

                            {Object.entries(filterKeys)?.map(([key, value]) => (
                                <div key={key} className="sk-drawer-filter-group">
                                    <div className='d-flex align-items-center gap-2'>
                                        <div className="task-list-filter-label">
                                            {value?.label} {filterValue?.[key]?.length > 0 ? `(${filterValue?.[key]?.length})` : ""}
                                        </div>
                                        {!_.isEmpty(filterValue?.[key]) &&
                                            <div title='Clear filter' className="c-pointer text-muted hover-primary" onClick={() => setFilterValue((prev) => ({ ...prev, [key]: [], selectedFilterKey: key }))}>
                                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                                            </div>
                                        }
                                    </div>
                                    {option?.[key]?.length > 0 ?
                                        <div className='d-flex gap-2 flex-wrap align-items-center mt-2'>
                                            {option?.[key]?.slice(0, optionCount?.[key])?.map((item, index) => {
                                                const isSelected = !_.isEmpty(_.findWhere(filterValue?.[key], { [value?.id]: item?.[value?.id] }));
                                                return (
                                                    <div key={index} className={`${value?.render ? "" : "px-2 py-1"} rounded-pill fw-semibold c-pointer border ${value?.type === "img" ? "border-3" : "border-1"} ${isSelected ? "border-primary text-primary bg-light" : "bg-light-gray"}`}
                                                        onClick={() => setFilterValue((prev) => ({ ...prev, [key]: isSelected ? prev?.[key]?.filter(i => i?.[value?.id] !== item?.[value?.id]) : prev?.[key] ? [...prev?.[key], item] : [item], selectedFilterKey: key }))}
                                                    >
                                                        {value?.render ? value?.render(item) : item?.[value?.key]}
                                                    </div>
                                                )
                                            })}
                                            {option?.[key]?.slice(optionCount?.[key])?.length > 0 &&
                                                <div style={{ width: "30px" }}>
                                                    <MultiSelect className='jira-like-dd' ref={multiselectRef} value={filterValue?.[key]} options={option?.[key]?.slice(optionCount?.[key])} onChange={(e) => setFilterValue((prev) => ({ ...prev, [key]: e.value, selectedFilterKey: key }))} optionLabel={value?.key} filter filterInputAutoFocus appendTo={document.body} panelClassName='w15' dropdownIcon={<FontAwesomeIcon icon="fa-solid fa-ellipsis" />} itemTemplate={value?.render ? (opt) => value?.render(opt, true) : undefined} />
                                                </div>
                                            }
                                        </div> : <div className='text-secondary'>No available options</div>
                                    }
                                </div>
                            ))}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Created Date</div>
                                <DatePicker
                                    ref={createdDatePickerRef}
                                    format='DD-MM-YYYY'
                                    style={{ width: "100%" }}
                                    placeholder='Select Date'
                                    range
                                    rangeHover
                                    value={filterValue?.createdDate}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, createdDate: e, isChange: true }));
                                        if (e && e.length === 2) {
                                            createdDatePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    onClose={() => { if (filterValue?.isChange) getTaskList() }}
                                />
                            </div>
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Updated Date</div>
                                <DatePicker
                                    ref={updatedDatePickerRef}
                                    format='DD-MM-YYYY'
                                    style={{ width: "100%" }}
                                    placeholder='Select Date'
                                    range
                                    rangeHover
                                    value={filterValue?.updatedDate}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, updatedDate: e, isChange: true }));
                                        if (e && e.length === 2) {
                                            updatedDatePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    onClose={() => { if (filterValue?.isChange) getTaskList() }}
                                />
                            </div>
                            <div className="sk-drawer-filter-group">
                                <div className='d-flex gap-2'>
                                    <div className='inspectra-calendar w-50'>
                                        <div className="task-list-filter-label">Start Date</div>
                                        <Calendar dateFormat='dd-mm-yy' className='sk-input-dd w-100' placeholder='Select Date' range rangeHover value={filterValue?.startDate} onChange={(e) => setFilterValue((prev) => ({ ...prev, startDate: e?.target?.value, isChange: true }))} onHide={() => { if (filterValue?.isChange) getTaskList() }} />
                                    </div>
                                    <div className='inspectra-calendar w-50'>
                                        <div className="task-list-filter-label">Due Date</div>
                                        <Calendar dateFormat='dd-mm-yy' className='sk-input-dd w-100' placeholder='Select Date' range rangeHover value={filterValue?.dueDate} onChange={(e) => setFilterValue((prev) => ({ ...prev, dueDate: e?.target?.value, isChange: true }))} onHide={() => { if (filterValue?.isChange) getTaskList() }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => { getTaskList(); setShowFiltersDrawer(false); }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskList;
